export const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname.includes("new-dev") ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export const isOnlyLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export const isReleaseEnvironment = Boolean(
  window.location.hostname.includes("new-rls")
);

/**
 * Ambiente de desenvolvimento: localhost/127.x, hosts "new-dev" e o subdomínio
 * dev do player (dev.dsmidia.com). Qualquer outro host é produção.
 *
 * Isso decide o backend (api/WebSocket midia-indoor-{stage}) que o player usa.
 * Uma TV só é alcançável pelo painel do MESMO ambiente — a conexão WebSocket
 * vive na API Gateway daquele stage.
 */
export const isDevEnvironment = Boolean(
  isLocalhost || window.location.hostname.startsWith("dev.")
);

export default isDevEnvironment ? "dev" : "prd";

// Endpoint do WebSocket por ambiente. O ID da API muda a cada recriação da
// WebSocket API no AWS — manter sincronizado com `serverless info -s <stage>`.
const WS_ENDPOINTS: Record<string, string> = {
  dev: "wss://fznocdko1l.execute-api.us-east-1.amazonaws.com/dev",
  prd: "wss://1zf2f8cc5m.execute-api.us-east-1.amazonaws.com/prd",
};

export const wsEndpoint = WS_ENDPOINTS[isDevEnvironment ? "dev" : "prd"];
